import React from "react";
import { TableRow } from "./TableRow";
import { NoRows } from "../../../layout/Table/NoRows";

function TableBody(props) {
  const renderRows = () => {
    const { tickets } = props;

    if (!Array.isArray(tickets) || tickets.length === 0) {
      return <NoRows colSpan="12" />;
    }

    return tickets.map(renderRow);
  };

  const renderRow = (ticket, index) => {
    const { actionCallback } = props;

    return (
      <TableRow
        key={index}
        ticket={ticket}
        actionCallback={actionCallback}
        index={index}
      />
    );
  };

  return <tbody>{renderRows()}</tbody>;
}

export { TableBody };
